/**
 * SCRUM-596: the sites slice lives in ./sitesSlice.ts (createSlice +
 * createAsyncThunk). This module re-binds the slice's public creators under
 * the legacy import path so the ~30 existing importers — components,
 * pageAction, pendingPagesActions and the jest.spyOn/jest.mock call-sites —
 * keep working unchanged. The re-binds are deliberate `export const`
 * assignments (not `export ... from`) so the CommonJS interop keeps the
 * properties writable for jest.spyOn. New code should import from
 * './sitesSlice'.
 *
 * Dropped legacy exports (no importer anywhere, verified during SCRUM-596):
 * addSiteGeneralContent, getAllSettings, updatePublishingStatement,
 * getPendingPages, getHistory, and the siteActions copy of addPendingPage
 * (consumers use pendingPagesActions.addPendingPage).
 */
import {
  clearMessage as _clearMessage,
  getSites as _getSites,
  addSite as _addSite,
  deleteSite as _deleteSite,
  restoreSite as _restoreSite,
  releaseSite as _releaseSite,
  getSite as _getSite,
  EditSite as _EditSite,
  getSitesForSiteselector as _getSitesForSiteselector,
  getSitesByDomain as _getSitesByDomain,
  getSettingVariablesToUpdate as _getSettingVariablesToUpdate,
  updateSettingVariables as _updateSettingVariables,
  deleteSettingsVariables as _deleteSettingsVariables,
  getCurrentSite as _getCurrentSite,
} from "./sitesSlice";

export const clearMessage = _clearMessage;
export const getSites = _getSites;
export const addSite = _addSite;
export const deleteSite = _deleteSite;
export const restoreSite = _restoreSite;
export const releaseSite = _releaseSite;
export const getSite = _getSite;
export const EditSite = _EditSite;
export const getSitesForSiteselector = _getSitesForSiteselector;
export const getSitesByDomain = _getSitesByDomain;
// SCRUM-1225: getSettingVariables removed with the design-level catalogue.
export const getSettingVariablesToUpdate = _getSettingVariablesToUpdate;
export const updateSettingVariables = _updateSettingVariables;
export const deleteSettingsVariables = _deleteSettingsVariables;
export const getCurrentSite = _getCurrentSite;
